import { ICON_COLOR } from '../menu';

export default function Add({ color = ICON_COLOR }) {
  return (
    <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.5001 10.8333H11.3334V15C11.3334 15.4583 10.9584 15.8333 10.5001 15.8333C10.0417 15.8333 9.66675 15.4583 9.66675 15V10.8333H5.50008C5.04175 10.8333 4.66675 10.4583 4.66675 10C4.66675 9.54167 5.04175 9.16667 5.50008 9.16667H9.66675V5.00001C9.66675 4.54167 10.0417 4.16667 10.5001 4.16667C10.9584 4.16667 11.3334 4.54167 11.3334 5.00001V9.16667H15.5001C15.9584 9.16667 16.3334 9.54167 16.3334 10C16.3334 10.4583 15.9584 10.8333 15.5001 10.8333Z'
        fill={color}
      />
    </svg>
  );
}
